import React from 'react';

import { IWordpressCTA, IWordpressImage } from '../../types/wordpress/blocks';
import { serializeImageForImageComponent } from '../../utils/serializeImageForImageComponent';
import { tw } from '../../utils/tailwind';
import { Box, Flex, Stack } from '../Core';
import Image from '../Image';
import StyledLink from '../StyledLink';
import ThemedButton from '../ThemedButton';
import HeroTextAndDecorator from './HeroTextAndDecorator';

export type CentreInfos = {
  name: string;
  adresse: string;
  telephone: string;
  email: string;
  facebook: string;
  instagram: string;
};

interface IStaticHeroProps {
  backgroundImage: IWordpressImage | null;
  couleurTitre: string | null;
  ctas?: IWordpressCTA[];
  heading?: string | null;
  kinequickForm?: JSX.Element;
  tagline?: string | null;
  overlay?: boolean;
}

const StaticHero: FCWithClassName<IStaticHeroProps> = (props) => {
  const { backgroundImage, couleurTitre, ctas, heading, kinequickForm, tagline } = props;

  const bgImageContent = (
    <Flex className={tw('items-center', props.overlay ? 'bg-[rgba(0,0,0,0.3)]' : '')}>
      <Stack
        className={tw(
          'space-y-8 lg:space-y-0 lg:static flex-col lg:flex-row lg:items-start lg:justify-between w-full px-[5%]',
          kinequickForm ? 'absolute -bottom-5' : null
        )}
      >
        <HeroTextAndDecorator couleurTitre={couleurTitre} title={heading} tagline={tagline} />
        {kinequickForm && <Box className="max-w-sm position-absolutew-11/12 lg:w-full">{kinequickForm}</Box>}
      </Stack>
      {ctas?.map((cta) => (
        <StyledLink
          key={cta.titre}
          to={cta.internalLink?.uri}
          href={cta.externalLink ?? undefined}
          anchorId={cta.anchor}
          state={cta.navigationProps}
        >
          <ThemedButton className="overlap-centered">{cta.titre}</ThemedButton>
        </StyledLink>
      ))}
    </Flex>
  );
  return (
    <Box className="relative w-full aspect-h-6 aspect-w-4 sm:aspect-w-6 md:aspect-w-9 xl:aspect-w-14">
      <Image
        image={serializeImageForImageComponent({
          image: backgroundImage ?? undefined,
        })}
        loading="eager"
        className="w-full"
      />
      {bgImageContent}
    </Box>
  );
};

export default StaticHero;
